<template>
	<div class="rules_bg">
		<div class="index_bg">
    
			<div class="btn">
			
	      <div class="butt">
				<van-button type="default" @click="code" size="large" class="index_btn"><img src="../assets/images/button3.png"></van-button>
	      </div>
	     
	    </div>
	    <div class="btn">
	      <div class="butt">
	      <router-link :to="{name: 'DatiRank'}"><van-button type="default" size="large" class="index_btn"><img src="../assets/images/button4.png" ></van-button>
	      </router-link>
	      </div>
	    </div>
	  </div>
	  <van-dialog v-model="cshow" title=" " :show-confirm-button="true" :beforeClose="closeCode">
          <div style="height: 56px;overflow: hidden;">
            <div class="l-captcha" data-callback="getResponse" data-site-key="776551c9cc8a35b7943aa0e9a9f625e5"></div>
        
          </div>
            <p class="ppppp">提示：若显示不出验证图片，请刷新页面</p>
        
				
			</van-dialog>
		<!-- <div class="w90">
			
			<h1 style="text-align: center;font-size: 2em;font-weight: bold; color:#fff">答题规则</h1>
			<div class="rule" v-html="rules">
				
			</div>
		</div> -->
	</div>
</template>
<script>
export default {
	data() {
        return {
            
            info: this.$store.state.acc,
            rules: this.$store.state.acc.rules,
            cshow:false,
            luosimao_code: '',
            user: this.$store.state.user,
            
        }
    },
     created() {
     	console.log(this.info.number)
	    
	    
	},
	methods: {
	  	init() {
	    this.$toast.loading({
	      message: '加载中...',
	      forbidClick: false,
	      duration: 10000
	    })
	    
		},
		closeCode(action, done) {
      let dom = document.getElementById("lc-captcha-response")
      if(dom.value) {
        this.luosimao_code = dom.value
        this.$store.commit('SET_LUOSIMAO_CODE', this.luosimao_code)
        // this.userinfo()
        this.start()
      }
      done()
    },
    code() {
      this.cshow = true
      // if(!window.LUOCAPTCHA) {
        let dom = document.getElementById("luosimao");
        if(dom){
           dom.parentNode.removeChild(dom);
        }
        var c = document.createElement('script');c.type = 'text/javascript';c.async = true;c.id="luosimao"
        c.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'captcha.luosimao.com/static/dist/captcha.js';
        var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(c, s);
      // }else{
      //   window.LUOCAPTCHA.reset()
      // }
      
      // return 
    },
    start() {
      let now_time=new Date();
      let y = now_time.getFullYear();
      let MM = now_time.getMonth() + 1;
      MM = MM < 10 ? ('0' + MM) : MM;
      let d = now_time.getDate();
      d = d < 10 ? ('0' + d) : d;
      let h = now_time.getHours();
      h = h < 10 ? ('0' + h) : h;
      let m = now_time.getMinutes();
      m = m < 10 ? ('0' + m) : m;
      let s = now_time.getSeconds();
      s = s < 10 ? ('0' + s) : s;
      this.time_now = y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s  ;      		
			
			console.log(this.info.number);
      if(this.time_now < this.info.start_time || this.time_now > this.info.end_time ){
        this.$dialog.alert({
          message: '活动暂未开放！',
        });
        return false
      }
      //答题时间在8:00到24:00之间
      let nowtime=new Date();
			
   //    if(now_time.getHours()>'8' && now_time.getHours()<'10' || now_time.getHours()>'12' && now_time.getHours()<'14' || now_time.getHours()>'17' && now_time.getHours()<'21'){
					
					
   //    }else{
			// 		this.$dialog.alert({
			// 			message: '请于8:00-10:00，12:00-14:00, 17:00-21:00 之间答题！',
			// 		});
			// 		return false
			// }
      
      //判断用户答题次数
      if(this.user.number == 0) {
        let message = '答题机会已经用完，请明天再来！'
        this.$dialog.confirm({
            message: message,
          });
          return
        
        
        
      }
      //跳转到答题页面
      this.$router.push({ name: 'DatiView', params: { q: this.info.code }})
      // 
	  
    }
	}
}
</script>
<style>
	.rules_bg{
	  background: url(../assets/images/rule.jpg) no-repeat center;
	  background-size: 100% 100%;
	  width: 100vw;
	  height: 100vh;
	  position: relative;
	  
	  overflow: hidden; color:#fff
	}
	.w90{
		width: 95%;
		margin: 0 auto;
		margin-top: 5vh;

	}
	.w90 img{
		width: 100%;
	}
	.title{
		width: 60%;
		margin: auto;
		margin-bottom: 15px;
	}
	.title img{
		width: 100%;

	}
	.rule{
		width: 80%;
		margin: auto;
		/* background: #fff; */
		border-radius: 5%;
		margin-top: 15px;
		padding-bottom: 20px;
		height: 50vh;
		overflow-y: auto;
	}
	.rule p{
		color: #fff;
		font-size: 14px;
		line-height: 2em;
		font-weight: bold;
		margin-left: 10px;
		margin-right: 10px;
	}
	.img{
		position: absolute;right: 0;bottom: 0;
		width: 50%;
	}
	.img img{
		width: 100%;
	}
	.index_bg{
		overflow: hidden;
		width: 80vw;
		margin: auto;
	}
	.index_bg .btn{
	width: 40vw;
	/*margin: auto;*/
  float: left;
  margin-top: 85vh;
}
.index_bg .btn .butt{
  width: 32vw;
  margin: auto;
  
}
.index_btn{
  margin-top: 3vh;
  /* width: 55vw; */
  /* height: 7vh; */
  font-size: 5vw;
  /* line-height: 7vh; */
  border-radius: 25px;
}
.index_btn:first-child{
  margin-top: 3vh;
}
.index_btn img{
	width: 100%;
	height: 100%;
}
.van-button--default{
	background-color: rgba(255,255,255,0);
	border: unset;
}
/*.van-button--large{
	height: unset;
}*/
/*#l-captcha-float_9qbmiexj5{
    top: 100px;
    left: 10%;

 }*/
 
 .l-captcha { margin: 10px auto;}
.ppppp{line-height: 30px;text-indent: 1em;
    font-size: 12px;color: #666;}
  
</style>